import React from "react";
import { RotateCcw } from "lucide-react";
import { FINANCE_ICONS } from "./financeConstants";
import { getFinanceCategoryColor } from "./financeConstants";
import FinanceDesktopTransactionCard from "./FinanceDesktopTransactionCard";
import FinanceDesktopTransactionRow from "./FinanceDesktopTransactionRow";

export default function FinanceDesktopTransactionPanel({
  selectedDate,
  setSelectedDate,
  availableCategories,
  selectedCategory,
  setSelectedCategory,
  filteredTransactions,
  isCalendarVisible,
  getDepartmentColor,
  onEdit,
  readOnlyMode,
  selectedDepartment,
}) {
  return (
    <div className="bg-white/60 backdrop-blur-xl p-6 rounded-[2.5rem] shadow-sm border border-white/40 flex-1 flex flex-col min-h-[300px]">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-black text-gray-800 flex items-center gap-2">
          <img src={FINANCE_ICONS.coin} width={24} alt="list" />
          {selectedDate ? `${selectedDate.getDate()}일 내역` : "전체 내역"}
        </h3>
        {selectedDate && (
          <button
            onClick={() => setSelectedDate(null)}
            className="flex items-center gap-1 px-3 py-1.5 rounded-xl bg-gray-100 text-gray-500 text-xs font-bold hover:bg-gray-200 transition"
          >
            <RotateCcw size={12} /> 전체 보기
          </button>
        )}
      </div>

      <div className="flex gap-2 mb-4 overflow-x-auto custom-scrollbar pb-2 px-1 pt-1">
        {availableCategories.map((cat) => {
          const isSelected = selectedCategory === cat;
          const categoryColorClass = getFinanceCategoryColor(cat).replace("bg-", "");

          return (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={`
                px-3 py-1.5 rounded-full text-xs font-bold whitespace-nowrap transition-all shadow-sm
                ${isSelected
                  ? `${getFinanceCategoryColor(cat)} text-white shadow-md scale-105 ring-2 ring-${categoryColorClass}/20`
                  : "bg-white border border-gray-100 text-gray-400 hover:bg-gray-50 hover:text-gray-600"}
              `}
            >
              {cat}
            </button>
          );
        })}
      </div>

      <div className={`flex-1 pr-1 ${isCalendarVisible ? "space-y-3 overflow-y-auto custom-scrollbar" : "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 auto-rows-max content-start"}`}>
        {filteredTransactions.length === 0 ? (
          <div className="col-span-full h-full flex flex-col items-center justify-center text-gray-400/60 pb-10">
            <img src={FINANCE_ICONS.coin} width={64} className="opacity-50 mb-2 grayscale" alt="empty" />
            <p className="text-sm font-bold text-gray-300">내역이 텅 비었어요!</p>
          </div>
        ) : (
          filteredTransactions.map((item) =>
            isCalendarVisible ? (
              <FinanceDesktopTransactionRow
                key={item.id}
                getDepartmentColor={getDepartmentColor}
                item={item}
                onEdit={onEdit}
                readOnlyMode={readOnlyMode}
                selectedDepartment={selectedDepartment}
              />
            ) : (
              <FinanceDesktopTransactionCard
                key={item.id}
                getDepartmentColor={getDepartmentColor}
                item={item}
                onEdit={onEdit}
                readOnlyMode={readOnlyMode}
                selectedDepartment={selectedDepartment}
              />
            )
          )
        )}
      </div>
    </div>
  );
}
